// src/component/Account/AccountLayout.jsx
import React, { useEffect, useState } from "react";
import { Outlet, NavLink } from "react-router-dom";
import Sidebar from "./Sidebar";
import { accountService } from "../../services/accountService";
import AnimSettings from "../ui/AnimSettings";
import "./account.css";

export default function AccountLayout() {
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setProfile(await accountService.getProfile());
      setLoading(false);
    })();
  }, []);

  return (
    <div className="acc-container">
      <h1 className="acc-h1">Mon compte</h1>

      <div className="acc-grid">
        <Sidebar loading={loading} profile={profile} />

        <div className="acc-content">
          {/* mini onglets responsives (optionnels) */}
          <div className="acc-tabsSm">
            <NavLink to="/account" end>Compte</NavLink>
            <NavLink to="/account/orders">Ordres</NavLink>
        
            <NavLink to="/account/deposit">Mon dépôt</NavLink>
            <NavLink to="/account/wishlist">Souhaits</NavLink>
          </div>

          <AnimSettings />

          <Outlet />
        </div>
      </div>
    </div>
  );
}
